import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
    readonly languages = [{ name: 'fr' }, { name: 'en' }];
}
